module.exports = "<div class=\"lds-roller\"><div></div><div></div><div></div><div>"